// extracted by mini-css-extract-plugin
export default {"select-field":"Administration_select-field__p-S1A"};